import { createSlice } from '@reduxjs/toolkit'

export const storeBlogsSlice = createSlice({
  name: 'storeBlogs',
  initialState: {
    value: [],
  },
  reducers: {
    setValue: (state, action) => {
      const blogToAdd = action.payload;

      state.value = blogToAdd;
    },
  },
})

// Action creators are generated for each case reducer function
export const { setValue } = storeBlogsSlice.actions

export default storeBlogsSlice.reducer